import debug from 'debug';
import {
    postUnrelatedIO,
    remoteError,
    remoteLoading,
    RemoteResource,
    remoteSuccess,
} from '../source';
import { Nullable } from '../util';
import { dispatchGeocoderState } from './events';
import {
    ServiceDescription,
    ServiceRequest,
    ServiceResponse,
    ServiceResponseIO,
} from './io';

const logger = debug('sdi:locale');

export interface GeocoderState {
    serviceList: ServiceDescription[];
    response: Nullable<RemoteResource<ServiceResponse>>;
    selected: Nullable<string>;
}
export const geocoderDefaultState: GeocoderState = {
    serviceList: [],
    response: null,
    selected: null,
};

export const queryService = (serviceRequest: ServiceRequest) => {
    dispatchGeocoderState(remoteLoading);
    return postUnrelatedIO(ServiceResponseIO, `/lookup/service`, serviceRequest)
        .then(data => {
            if (data.error) {
                dispatchGeocoderState(remoteError(data.error));
            } else {
                dispatchGeocoderState(remoteSuccess(data));
            }
        })
        .catch(err => {
            logger(`geocoder error: ${err.toString()}`);
            dispatchGeocoderState(remoteError(err));
        });
};

logger('loaded');
